import Swal from 'sweetalert2'

export default {
    methods: {
        showSuccess() {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'บันทึกข้อมูลสำเร็จ!',
                showConfirmButton: false,
                timer: 1500
            })
        },
        showUpdate() {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'แก้ไขข้อมูลสำเร็จ!',
                showConfirmButton: false,
                timer: 1500
            })
        },
        showDelete() {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'ลบข้อมูลสำเร็จ!',
                showConfirmButton: false,
                timer: 1500
            })
        },
        showError(msg) {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'เกิดข้อผิดพลาด!',
                text: msg + ' กรุณาติดต่อผู้ดูแลระบบ',
                showConfirmButton: false,
                timer: 2000
            })
        },
        showValidate() {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'ผิดพลาด!',
                text: 'กรุณาระบุข้อมูลให้ถูกต้องครบถ้วน',
                showConfirmButton: false,
                timer: 2000
            })
        },
        async showConfirm() {
            const res = await Swal.fire({
                title: "ยืนยัน?",
                text: "คุณต้องการลบหรือไม่!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                confirmButtonText: "ใช่ ลบข้อมูลนี้!",
                cancelButtonText: "ไม่ใช่",
            })
            return res.isConfirmed;
        }
    },
}